<template>
  <div
    v-if="
      GET_ACCOUNT_DATA.id == 1 ||
        has_perm('create_apartment') ||
        has_perm('update_apartment')
    "
  >
    <div class="box box-primary">
      <div class="box-header with-border" style="padding-bottom: 0">
        <!-- <h3 class="box-title">{{ $t(pagetitle) }}</h3> -->
        <div>
          <ul class="nav nav-tabs">
            <li class="active" @click="onClickTabSelect(1)">
              <a data-toggle="tab" href="#assetListV2"
                ><b>{{ $t(pagetitle) }}</b></a
              >
            </li>
            <li @click="onClickTabSelect(2)">
              <a data-toggle="tab" href="#supplierManagement"
                ><b>{{ $t("receiptReceiveInfo.title") }}</b></a
              >
            </li>
          </ul>

          <!-- <div class="tab-content">
            <div id="assetListV2" class="tab-pane fade in active">
            </div>
            <div id="supplierManagement" class="tab-pane fade">
            </div>
          </div> -->
        </div>
      </div>

      <form class="form-horizontal" v-show="isShowTabSelect(1)">
        <div class="box-body">
          <div class="col-md-6">
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <label class="col-sm-4 col-md-4 col-lg-4 control-label">{{
                    $t("apartment.apartment_code")
                  }}</label>
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <input
                      :disabled="apartment.id !== 0"
                      v-model="apartment.apartment_code"
                      type="text"
                      class="form-control"
                      :placeholder="$t('apartment.apartment_code')"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <label class="col-sm-4 col-md-4 col-lg-4 control-label">{{
                    $t("apartment.size")
                  }}</label>
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <input
                      :disabled="apartment.id !== 0"
                      v-model="apartment.size"
                      type="text"
                      class="form-control"
                      :placeholder="$t('apartment.size')"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <label class="col-sm-4 col-md-4 col-lg-4 control-label">{{
                    $t("apartment.rental_status")
                  }}</label>
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <b-form-select
                      required
                      v-model="apartment.status"
                      class="form-control"
                      :disabled="$route.params.id == 0"
                    >
                      <b-form-select-option
                        v-for="(item, index) in apartmentStatusOptions"
                        :key="(item, index)"
                        :value="item.value"
                      >{{ $t(item.text) }}</b-form-select-option>
                    </b-form-select>
                    <small
                      :style="{
                        visibility: apartment.status !== 1 ? 'visible' : 'hidden'
                      }"
                      class="form-text text-muted required"
                    >
                      <font color="red">*</font> {{ $t("apartment.rental_note") }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <label class="col-sm-4 col-md-4 col-lg-4 control-label">{{
                    $t("apartment.other_details")
                  }}</label>
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <b-form-input
                      type="text"
                      v-model="apartment.other_details"
                      :placeholder="$t('apartment.other_details')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row" v-show="infoShow && apartment.status > 1">
              <apartmentOwnerDetail
                :apartment_id="apartment.id"
                :apartment_code="apartment.apartment_code"
                @mainperson-save="reload_apartment_details"
                @customer="handleDataCustomer"
                @currentDebt="getCurrentDebt"
              />
            </div>
          </div>
          <!-- <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment.bedroom_count")
            }}</label>
            <div class="col-sm-1 col-md-1 col-lg-1">
              <b-form-input
                type="number"
                required
                v-model="apartment.bedroom_count"
                :placeholder="$t('apartment.bedroom_count')"
              />
            </div>
          </div> -->

          <!-- BEGIN - Disable -->
          <div class="form-group" v-show="false">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment.bathroom_count")
            }}</label>
            <div class="col-sm-1 col-md-1 col-lg-1">
              <b-form-input
                type="number"
                required
                v-model="apartment.bathroom_count"
                :placeholder="$t('apartment.bathroom_count')"
              />
            </div>
          </div>

          <div class="form-group" v-show="false">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment.room_count")
            }}</label>
            <div class="col-sm-1 col-md-1 col-lg-1">
              <b-form-input
                type="number"
                required
                v-model="apartment.room_count"
                :placeholder="$t('apartment.room_count')"
              />
            </div>
          </div>
          <!-- END - Disable -->

          <!-- BEGIN - Add new field -->
          <!-- <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment.block")
            }}</label>
            <div class="col-sm-1 col-md-1 col-lg-1">
              <b-form-input
                type="text"
                :disabled="apartment.id !== 0"
                v-model="apartment.block"
                :placeholder="$t('apartment.block')"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment.floor")
            }}</label>
            <div class="col-sm-1 col-md-1 col-lg-1">
              <b-form-input
                type="text"
                :disabled="apartment.id !== 0"
                v-model="apartment.floor"
                :placeholder="$t('apartment.floor')"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment.room")
            }}</label>
            <div class="col-sm-1 col-md-1 col-lg-1">
              <b-form-input
                type="text"
                :disabled="apartment.id !== 0"
                v-model="apartment.room"
                :placeholder="$t('apartment.room')"
              />
            </div>
          </div> -->

          <!-- END - Add new field -->

        </div>
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="onApartmentCancel"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <!-- <button
            type="button"
            class="btn btn-labeled btn-primary"
            v-if="
              (APARTMENT_DETAIL_DATA.apt_type == 1 &&
                has_perm('update_apartment')) ||
                GET_ACCOUNT_DATA.id == 1
            "
            @click="onConfirm"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-home"></i>
            </span>
            {{ $t("apartment.rent") }}
          </button> -->
          <!-- <button
            type="button"
            class="btn btn-labeled btn-primary"
            v-if="
              (APARTMENT_DETAIL_DATA.apt_type == 2 &&
                has_perm('update_apartment')) ||
                GET_ACCOUNT_DATA.id == 1
            "
            @click="onConfirm"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-pause"></i>
            </span>
            {{ $t("apartment.stop_rent") }}
          </button> -->
          <button
            v-if="
              has_perm('update_apartment') ||
                GET_ACCOUNT_DATA.id == 1 ||
                has_perm('create_apartment')
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onApartmentSubmit"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </form>
      <ReceiptReceiveInfo 
        v-show="isShowTabSelect(2)"
        :apartmentId="apartment.id"
        ref="receiptReceiveInfo"/>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <div v-show="infoShow && apartment.status > 1 && isShowTabSelect(1)">
      <apartmentMember 
        :apartment_id="apartment.id"
        :apartment_code="apartment.apartment_code"
        @mainperson-save="reload_apartment_details"
        @currentDebt="getCurrentDebt"
      />
      <apartmentTenant
        :apartment_id="apartment.id"
        :apartment_code="apartment.apartment_code"
        @mainperson-save="reload_apartment_details"
        @tenant="handDataTenant"
        @currentDebt="getCurrentDebt"
      />
      <apartment-history :apartmentId="apartment.id"/>
    </div>
    <!-- <div v-show="infoShow && apartment.status > 1">
      <main-contact-details
        :apartment_id="apartment.id"
        :apartment_code="apartment.apartment_code"
        @mainperson-save="reload_apartment_details"
        @customer="handleDataCustomer"
        @currentDebt="getCurrentDebt"
      />
      <apartment-info
        :apartmentdetails="APARTMENT_DETAIL_DATA"
      ></apartment-info>
    </div>
    <apartment-assets
      :apartment_id="apartment.id"
      :apartment_code="apartment.apartment_code"
      :apartment_from="apartment.apartment_from"
    /> -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <router-view></router-view>

    <!-- START MODAL CONFIRM WATER, ELECTRIC VALUE -->
    <div class="modal fade" id="modal-confirm">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h3
              v-if="
                (APARTMENT_DETAIL_DATA.status == 1 &&
                  APARTMENT_DETAIL_DATA.apt_type == 2) ||
                  APARTMENT_DETAIL_DATA.apt_type == 1
              "
            >
              {{ $t("common.confirm") }}
            </h3>
            <h3
              v-if="
                APARTMENT_DETAIL_DATA.status == 2 &&
                  APARTMENT_DETAIL_DATA.apt_type == 2
              "
            >
              {{ $t("apartment.title_notification") }}
            </h3>
          </div>
          <div
            v-if="
              APARTMENT_DETAIL_DATA.status == 1 &&
                APARTMENT_DETAIL_DATA.apt_type == 2
            "
            class="modal-body"
          >
            <p>{{ $t("apartment.confirm_rent_to_resident") }}</p>
          </div>
          <div
            v-if="
              APARTMENT_DETAIL_DATA.status == 2 &&
                APARTMENT_DETAIL_DATA.apt_type == 2
            "
            class="modal-body"
          >
            <p>{{ $t("apartment.content_modal_rent_to_resident_head") }}</p>
            <p>
              <label>{{ $t("apartment.electric") }}: </label
              ><span>{{ e_this_value }}</span
              ><span>{{ $t("apartment.electric_unit") }}</span>
            </p>
            <p>
              <label>{{ $t("apartment.water") }}: </label
              ><span>{{ w_this_value }}</span
              ><span>{{ $t("apartment.water_unit") }}</span>
            </p>
            <p>{{ $t("apartment.content_modal_rent_to_resident_tail") }}</p>
          </div>
          <div
            v-if="
              APARTMENT_DETAIL_DATA.status == 1 &&
                APARTMENT_DETAIL_DATA.apt_type == 1
            "
            class="modal-body"
          >
            <p>{{ $t("apartment.confirm_resident_to_rent") }}</p>
          </div>
          <div
            v-if="
              APARTMENT_DETAIL_DATA.status == 2 &&
                APARTMENT_DETAIL_DATA.apt_type == 1
            "
            class="modal-body"
          >
            <p>{{ $t("apartment.confirm_resident_to_rent_2") }}</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-left"
              style="margin-bottom: 0"
              @click="closeModalConfirm"
            >
              {{ $t("common.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm"
              @click="confirmUpdateApartment"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!-- END MODAL CONFIRM WATER, ELECTRIC VALUE -->
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
// import MainContactDetails from "./MainContactDetails";
// import ApartmentAsset from "./ApartmentAssets";
import apartmentOwnerDetail from "./ApartmentOwnerDetail"
import apartmentMember from "./ApartmentMember"
import apartmentTenant from "./ApartmentTenant"
import ApartmentHistory from "./ApartmentHistory"
import ReceiptReceiveInfo from "./ReceiptReceiveInfo"
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
import moment from "moment";
import Enum from "../../../enum/enum"

export default {
  name: "ApartmentAdd",
  data() {
    return {
      infoShow: false,
      apartmentStatusOptions: [
        { text: "apartment_status.not_handover", value: 1 },
        { text: "apartment_status.handover", value: 2 },
        // { text: "apartment_status.occupied", value: 3 }
      ],
      isExistTenant: false,
      pagetitle: "apartment.editaddnew[0]",
      apartment: {
        id: 0,
        apartment_code: "",
        apartment_from: "ApartmentAdd",
        size: "",
        status: 1,
        not_rent: true,
        bathroom_count: 0,
        bedroom_count: 0,

        block: "",
        floor: 0,
        room: 0,
        other_details: "",
        leasebackService: false
      },
      currentDebt: 0,
      customer_name: "",
      identification_card: "",
      e_last_value: 0,
      e_this_value: 0,
      w_last_value: 0,
      w_this_value: 0,
      from_date: null,
      to_date: null,
      export_invoice_to: "",
      invoice_number: null,
      is_duplicate_confirm_value: false,
      apartment_monthly_e_id: 0,
      apartment_monthly_w_id: 0,
      invoice_id: null,
      isLoading: false,
      keyCheckShowApartmentExtraInfo: Enum.defaultExtraInfoList.APARTMENT_EXTRA_INFO,
      tenant_name: null,
      // 
      tabSelect: 1
    };
  },

  watch: {
    APARTMENT_DETAIL_DATA: function() {
      this.apartment.apartment_code = this.APARTMENT_DETAIL_DATA.apartment_code;
      this.apartment.size = this.APARTMENT_DETAIL_DATA.size;
      this.apartment.status = this.APARTMENT_DETAIL_DATA.status;
      this.apartment.not_rent = !this.APARTMENT_DETAIL_DATA.rent;
      this.apartment.bathroom_count = this.APARTMENT_DETAIL_DATA.bathroom_count;
      this.apartment.bedroom_count = this.APARTMENT_DETAIL_DATA.bedroom_count;
      this.apartment.room_count = this.APARTMENT_DETAIL_DATA.room_count;

      this.apartment.block = this.APARTMENT_DETAIL_DATA.block;
      this.apartment.floor = this.APARTMENT_DETAIL_DATA.floor;
      this.apartment.room = this.APARTMENT_DETAIL_DATA.room;
      this.apartment.other_details = this.APARTMENT_DETAIL_DATA.other_details;
      this.apartment.apt_type = this.APARTMENT_DETAIL_DATA.apt_type;

      // disable "Chưa Bàn Giao" option
      if (this.apartment.status >= 2) {
        this.apartmentStatusOptions = [
          { text: "apartment_status.not_handover", value: 1, disabled: true },
          { text: "apartment_status.handover", value: 2 },
          { text: "apartment_status.occupied", value: 3 }
        ];
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 3000);
    },
    //Get resident data and check exist or not exist tenant
    GET_RESIDENT_DATA: function() {
      for (let i = 0, size = this.GET_RESIDENT_DATA.length; i < size; i++) {
        let resident = this.GET_RESIDENT_DATA[i];
        if (resident.isTenant == true || resident.isTenant == "Yes") {
          this.isExistTenant = true;
        } else {
          this.isExistTenant = false;
        }
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 3000);
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "APARTMENT_DETAIL_DATA",
      "GET_RESIDENT_DATA",
      "GET_ACCOUNT_DATA",
      "GET_LAST_THIS_W_E_MONTH_VALUE_DATA",
      "GET_ACCOUNT_DATA",
      "GET_SERVICE_DATA"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ADD_APARTMENT",
      "UPDATE_APARTMENT",
      "GET_APARTMENT_DETAIL",
      "ON_SHOW_TOAST",
      "GET_RESIDENT_LIST",
      "CHANGE_RESIDENT_TO_SERVICE_APARTMENT",
      "GET_LAST_THIS_W_E_MONTH_VALUE",
      "GENERATE_INVOICE_ID"
    ]),
    generateInvoiceNumberOption3: function(subObject) {
      return this.GENERATE_INVOICE_ID().then(
        function(res) {
          let result = res.data;
          this.invoice_number = result;
          return result;
        }.bind(this)
      );
    },
    closeModalConfirm: function() {
      $("#modal-confirm").modal("hide");
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    reload_apartment_details: function() {
      let id = this.$route.params.id;
      if (parseInt(id) !== 0) {
        this.GET_APARTMENT_DETAIL({ id: id });
      }
    },
    getLastThisWEMonthValue: function() {
      //  căn hộ đã bàn giao => chốt điện & nước // không xuất phiếu báo
      let currentDate = new Date();
      let getCurrentMonth = currentDate.getMonth() + 1;
      let date_to = new Date();
      // Set default first day of month for date_from
      let date_from = new Date();
      date_from.setDate(sessionStorage.getItem('projectMonthlyCalculatePeriodStart'));
      date_to.setDate(sessionStorage.getItem('projectMonthlyCalculatePeriodEnd'));
      date_from.setMonth(getCurrentMonth - 2);
      this.from_date = utils.formatSqlDate(date_from, null, "DD/MM/YYYY");
      this.to_date = utils.formatSqlDate(date_to, null, "DD/MM/YYYY");
      let data = {
        params: {
          apartment_id: this.$route.params.id,
          from_date: this.from_date,
          to_date: this.to_date
        }
      };
      this.GET_LAST_THIS_W_E_MONTH_VALUE(data).then(
        function(res) {
          let data = res.data.data;
          this.is_duplicate_confirm_value = data.is_duplicate_confirm_value;
          for (
            let i = 0, size = data.apartment_monthly_usage.length;
            i < size;
            i++
          ) {
            if (this.is_duplicate_confirm_value) {
              this.from_date = moment(data.apartment_monthly_usage[i].date_to).add(1, "days").format("DD/MM/YYYY");
            }
            if (data.apartment_monthly_usage[i].service.id == 1) {
              // Get invoice id
              this.invoice_id =
                data.apartment_monthly_usage[i].invoice &&
                data.apartment_monthly_usage[i].invoice.id;
              // Get electric last value
              this.e_last_value = !utils.isNull(
                data.apartment_monthly_usage[i].this_month_value
              )
                ? data.apartment_monthly_usage[i].this_month_value
                : 0;
              // Get electric this value
              this.e_this_value = this.e_last_value;
              // Get apartment monthly usage electric id
              this.apartment_monthly_e_id =
                data.apartment_monthly_usage[i].id;
            } else if (data.apartment_monthly_usage[i].service.id == 2) {
              // Get invoice id
              this.invoice_id =
                data.apartment_monthly_usage[i].invoice &&
                data.apartment_monthly_usage[i].invoice.id;
              // Get electric last value by case export invoice or not export
              this.w_last_value = !utils.isNull(
                data.apartment_monthly_usage[i].this_month_value
              )
                ? data.apartment_monthly_usage[i].this_month_value
                : 0;
              // Get electric this value
              this.w_this_value = this.w_last_value;
              // Get apartment monthly usage water id
              this.apartment_monthly_w_id =
                data.apartment_monthly_usage[i].id;
            }
          }
          $("#modal-confirm").modal("show");
        }.bind(this)
      )
      .catch(function(error) {
        this.ERROR_TOAST();
      });
    },
    onConfirm: function() {
      if (this.apartment.status == 2 && this.apartment.apt_type == 2) {
        this.getLastThisWEMonthValue();
      } else {
        $("#modal-confirm").modal("show");
      }
    },
    onApartmentCancel: function() {
      let routeQuery = this.$route.query
      this.$router.push({
        name: "ApartmentList",
        query: {
          apartmentCode: routeQuery && routeQuery.apartmentCode,
          fromSize: routeQuery && routeQuery.fromSize,
          toSize: routeQuery && routeQuery.toSize,
          ownerResident: routeQuery && routeQuery.ownerResident,
          statusSelected: routeQuery && routeQuery.statusSelected
        }
      });
    },
    handleDataCustomer: function(callBackData) {
      this.export_invoice_to = callBackData;
      this.customer_name =
        callBackData.customer.first_name + callBackData.customer.last_name;
      this.identification_card =
        callBackData.customer.identificationnumber &&
        callBackData.customer.identificationnumber;
    },
    handDataTenant: function(data){
      this.tenant_name = data.tenant.first_name + data.tenant.last_name;
    },
    validateData: function() {
      let validatedResult = "OK";
      let validation_keys = ["apartment_code", "size"];
      for (let key in this.apartment) {
        if (validation_keys.indexOf(key) < 0) {
          continue;
        } else if (this.apartment[key] === null || this.apartment[key] === "") {
          validatedResult = `Thiếu ${key}`;
          break;
        } else {
          //
        }
      }
      if ((utils.isEmptyString(this.tenant_name) && utils.isEmptyString(this.customer_name)) && this.apartment.status != 1) {
        validatedResult = this.$t('apartment.errorOwnerOrTenantIsNull');
      }
      return validatedResult;
    },
    onApartmentSubmit: function(event) {
      let result = this.validateData();
      if (result == "OK") {
        let data = {
          apartment_code: this.apartment.apartment_code,
          size: this.apartment.size,
          status: this.apartment.status,
          rent: !this.apartment.not_rent,
          bathroom_count: this.apartment.bathroom_count,
          bedroom_count: this.apartment.bedroom_count,
          room_count: this.apartment.room_count,

          block: this.apartment.block,
          floor: this.apartment.floor,
          room: this.apartment.room,
          other_details: this.apartment.other_details,
          leaseback_service: this.apartment.leasebackService
        };
        if (parseInt(this.apartment.id) == 0) {
          this.ADD_APARTMENT({ data: data })
            .then(
              function() {
                this.onApartmentCancel()
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        } else {
          this.UPDATE_APARTMENT({ id: this.apartment.id, data: data })
            .then(
              function() {
                this.onApartmentCancel()
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        }
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },
    getCurrentDebt: function(currentDebt) {
      this.currentDebt = currentDebt;
    },

    confirmUpdateApartment: function() {
      $("#modal-confirm").modal("hide");
      let result = this.validateData();
      if (result == "OK") {
        if (this.apartment.apt_type == 1) {
          this.apartment.apt_type = 2;
          this.apartment.not_rent = true;
        } else {
          this.apartment.apt_type = 1;
          this.apartment.not_rent = false;
        }

        let data = {
          apt_type_id: this.apartment.apt_type,
          rent: this.apartment.not_rent,
          apartment_code: this.apartment.apartment_code,
          size: this.apartment.size,
          status: this.apartment.status,
          bathroom_count: this.apartment.bathroom_count,
          bedroom_count: this.apartment.bedroom_count,
          room_count: this.apartment.room_count,

          block: this.apartment.block,
          floor: this.apartment.floor,
          room: this.apartment.room,
          other_details: this.apartment.other_details
        };

        this.isLoading = true;
        this.UPDATE_APARTMENT({ id: this.apartment.id, data: data }).then(
          function() {
            let apartment_type = "service_apt";
            if (this.APARTMENT_DETAIL_DATA.apt_type == 2) {
              // from service to resident
              apartment_type = "resident_apt";
            }
            let payload = {
              data: [this.apartment.id],
              apartment_type: apartment_type
            };
            this.CHANGE_RESIDENT_TO_SERVICE_APARTMENT(payload)
              .then(
                function() {
                  this.isLoading = false;
                  this.SUCCESS_TOAST();
                  this.onApartmentCancel()
                }.bind(this)
              )
              .catch(
                function(error) {
                  this.ON_SHOW_TOAST({
                    message: error.response.data.message,
                    styleType: "danger"
                  });
                }.bind(this)
              );
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },
    onClickTabSelect: function(value) {
      this.tabSelect = value
      switch (value) {
        case 2:
          if (this.$refs.receiptReceiveInfo != undefined) {
            this.$refs.receiptReceiveInfo.onRefreshData()
          }
          break;
        default:
          break;
      }
    },
    isShowTabSelect: function(value) {
      if (this.tabSelect === value) {
        return true
      }
      return false
    }
  },
  mounted() {
    this.generateInvoiceNumberOption3();
    let id = this.$route.params.id;
    if (parseInt(id) !== 0) {
      this.apartment.id = parseInt(id);
      this.pagetitle = "apartment.editaddnew[1]";
      this.infoShow = true;
      const data = {
        params: {
          apartment: this.apartment.id
        }
      };
      this.isLoading = true;
      this.GET_RESIDENT_LIST(data).then(
        function() {
          this.isLoading = false;
          let id = this.$route.params.id;
          if (parseInt(id) !== 0) {
            // this.isLoading = true;
            this.GET_APARTMENT_DETAIL({ id: id }).then(
              function() {
              }.bind(this)
            )
            .catch(function(error) {
              this.isLoading = false;
            });
          }
        }.bind(this)
      )
      .catch(
        function(error) {
          this.isLoading = false;
        }.bind(this)
      );
    } else {
      //
    }
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    // "main-contact-details": MainContactDetails,
    // "apartment-assets": ApartmentAsset,
    loading: Loading,
    apartmentOwnerDetail,
    apartmentMember,
    apartmentTenant,
    ApartmentHistory,
    ReceiptReceiveInfo
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentAdd.vue